export class SetTenant {
  static readonly type = '[PREFERENCES] Set Tenant';
  constructor(public payload: string) {}
}

export class SetProject {
  static readonly type = '[PREFERNCES] Set Project';
  constructor(public payload: string) {}
}
